import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

// Сообщения основателей (телеграм-стиль) — появляются по очереди.
const MESSAGES = [
  {
    text: 'Чтобы научиться круто вести переговоры, нужно иметь возможность контролировать их ход',
    name: 'Клименко Юрий',
    initial: 'Ю',
  },
  {
    text: 'Главное в коммуникации не то, какой приём вы выбрали, а то, КАК вы его выбрали',
    name: 'Клименко Александра',
    initial: 'А',
  },
];

function HomePage() {
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const timers = MESSAGES.map((_, i) =>
      setTimeout(() => setVisible((prev) => [...prev, i]), i * 1500 + 600)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="home">
      <div className="home-grid" aria-hidden="true"></div>

      <section className="hero">
        <div className="hero-inner">
          <div className="hero-content">
            <a className="hero-logo" href="/">
              <img
                src="https://static.tildacdn.com/tild6363-3066-4739-a533-316439323439/logo.svg"
                alt="Soft Skills Lab"
              />
            </a>

            <span className="hero-eyebrow">
              <span className="dot"></span>
              Soft Skills Lab
            </span>

            <h1 className="hero-title">
              AI-тренажёр закрепления способов мышления <span className="accent">SSL</span>
            </h1>

            <div className="hero-cta">
              <Link to="/ai" className="btn btn-primary">
                Разобрать свой кейс
                <span aria-hidden="true">↗</span>
              </Link>
              <span className="btn btn-secondary is-disabled" aria-disabled="true">
                Учиться на активных кейсах
                <span className="soon">скоро</span>
              </span>
            </div>
          </div>

          <div className="hero-messages">
            {MESSAGES.map((m, i) => (
              <div key={i} className={`msg ${visible.includes(i) ? 'visible' : ''}`}>
                <div className="msg-bubble">
                  <p className="msg-text">{m.text}</p>
                  <p className="msg-name">{m.name}</p>
                </div>
                <div className="msg-avatar">{m.initial}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
